/**
 * @author czy
 * 功能：会计期间页面
 */

import { Service } from '@/tools'

export class AccountingPeriodService<T extends TSettle.AccountingPeriod> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.AccountingPeriod}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询所有会计科目
  // /api/settle/accountingPeriod/v1/list
  list = <K extends T['ApiList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiList', data)

  // 新增会计期间 /api/settle/accountingPeriod/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)
}
